import React, { memo } from 'react';
import { NavLink } from 'react-router-dom';

const RouteTab = ({ disabled = false, children, ...props }) => (
  <NavLink
    {...props}
    className={`ThemedRouteTabs__tab ${props?.className || ''} ${
      disabled ? 'ThemedRouteTabs__tab--disabled' : ''
    }`}
    activeClassName={`ThemedRouteTabs__tab--selected ${props?.activeClassName || ''}`}
  >
    {children}
  </NavLink>
);

export default memo(RouteTab);
